import { useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
// Components
import WhatsappFloatButton from './WhatsappFloatButton';
import { Alert, NotFoundPage, ScrollRestoration, TimeOnPageProfiler } from './common';
import { Footer } from './footer';
import { Header, LoginHeader, NavHeader, SimpleHeader } from './header';
import { Preferences } from './preferences';
import { UserValidate, Wishlist } from './user';
import UtmManager from './common/containers/UtmManager';
// Styles
import 'bootstrap/dist/css/bootstrap.css';
import 'instantsearch.css/themes/reset.css';
import './App.css';
// Sentry
import { AdvertisingPopup } from './advertising';
import CartIndicatorBottomSheet from './current-order/containers/CartIndicatorBottomSheet';

const AppContent = ({ routes, theme, mfaPending, mfaEmail }) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (mfaPending && mfaEmail) {
      history.push('/verify-mfa');
    }
  }, [mfaPending, mfaEmail, history]);

  return (
    <ScrollRestoration>
      <div id="app" className={`theme-${location.pathname === '/' && theme}`}>
        <UtmManager />
        <Wishlist />
        <Preferences />
        <UserValidate />
        <Alert />
        <WhatsappFloatButton />
        <AdvertisingPopup />
        {/* <LocationPopup /> */}
        <TimeOnPageProfiler />

        <header>
          <Switch>
            <Route path="/checkout" component={SimpleHeader} />
            <Route path="/login" component={LoginHeader} />
            <Route path="/cadastro" component={SimpleHeader} />
            <Route path="/registro" component={SimpleHeader} />
            <Route path="/esqueci-senha" component={Header} />
            <Route path="/resetar-senha" component={Header} />
            <Route path="/confirmacao" component={SimpleHeader} />
            <Route path="/pix-payment" component={SimpleHeader} />
            <Route path="/blog" component={NavHeader} />
            <Route path="/lp" component={Header} />
            <Route path="/verify-mfa" component={LoginHeader} />
            <Route component={Header} />
          </Switch>
        </header>
        <main>
          <Switch>
            {routes.map((route, i) => {
              const { component, ...options } = route;
              return <Route key={i} component={component} {...options} />;
            })}
            <Route component={NotFoundPage} />
          </Switch>
          <CartIndicatorBottomSheet />
        </main>
        <footer>
          <Switch>
            <Route component={Footer} />
          </Switch>
        </footer>
      </div>
    </ScrollRestoration>
  );
};

export default AppContent;
